import { FilterItem, FilterType } from "src/app/shared/modules/filters/filters.component";

export const SUMMARY_FILTERS = (_self: any): FilterItem[] => {
    return [
        {
            label: 'Stylist',
            filterType: FilterType.dropdown,
            data: [],
            displayKey: 'stylist_name',
            filterKey: 'stylist_id',
            filterId: 'stylist'
        },
        {
            label: 'Joined After',
            filterType: FilterType.datepicker,
            filterId: 'after_date'
        },
        {
            label: 'Joined Before',
            filterType: FilterType.datepicker,
            filterId: 'before_date'
        }
    ];
}

export const Colors = [
    "#42A5F5",
    "#66BB6A",
    "#FFA726",
    "#26C6DA",
    "#7E57C2"
]

export const BarChartOptions: any = {
    plugins: {
      legend: {
        labels: {
          color: '#495057'
        }
      }
    },
    scales: {
      x: {
        ticks: {
          color: '#495057'
        },
        grid: {
          color: '#ebedef'
        }
      },
      y: {
        ticks: {
          color: '#495057'
        },
        grid: {
          color: '#ebedef'
        }
      }
    }
  };


  export const DoughnutChartOptions: any = {
    plugins: {
      legend: {
        labels: {
          color: '#495057'
        }
      }
    }
  }